import { Box, Stack, Typography, alpha, useTheme } from '@mui/material';
import emptyIcon from "../../assets/empty-icon.svg"

export function NoFilterTablePlaceholder() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid ${alpha(theme.palette.divider, 1)}`,
        borderRadius: '12px',
        backgroundColor: 'background.paper',
        py: 8,
        px: 3,
        height:300
      }}
    >
      <Stack alignItems="center" spacing={1.5}>
        <Box
        component="img"
        src={emptyIcon}
        alt="empty"
          sx={{
            width: 40,
            height: 40,
            borderRadius: '10px'
          }}
        > 
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          No data to display
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Enter a School ID and click &quot;Get Data&quot; to view insights.
        </Typography>
      </Stack>
    </Box>
  );
}
